import { render, staticRenderFns } from "./BaseGroup.vue?vue&type=template&id=bf1d8094"
import script from "./BaseGroup.vue?vue&type=script&lang=js"
export * from "./BaseGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports